// Generated by purs version 0.15.0
import * as Control_Applicative from "../Control.Applicative/index.js";
import * as Control_Bind from "../Control.Bind/index.js";
import * as Control_Monad_Cleanup from "../Control.Monad.Cleanup/index.js";
import * as Control_Monad_Reader_Trans from "../Control.Monad.Reader.Trans/index.js";
import * as Control_Monad_Trans_Class from "../Control.Monad.Trans.Class/index.js";
import * as Data_Functor from "../Data.Functor/index.js";
import * as Data_Maybe from "../Data.Maybe/index.js";
import * as Data_Monoid from "../Data.Monoid/index.js";
import * as Data_Semigroup from "../Data.Semigroup/index.js";
import * as Data_Tuple from "../Data.Tuple/index.js";
import * as Data_Unit from "../Data.Unit/index.js";
import * as Effect from "../Effect/index.js";
import * as Effect_Class from "../Effect.Class/index.js";
import * as Foreign_Object from "../Foreign.Object/index.js";
import * as Specular_Dom_Browser from "../Specular.Dom.Browser/index.js";
import * as Specular_FRP_Base from "../Specular.FRP.Base/index.js";
import * as Specular_FRP_Replaceable from "../Specular.FRP.Replaceable/index.js";
import * as Specular_FRP_WeakDynamic from "../Specular.FRP.WeakDynamic/index.js";
var text = function (dict) {
    return dict.text;
};
var rawHtml = function (dict) {
    return dict.rawHtml;
};
var onDomEvent = function (dictMonadFRP) {
    return function (eventType) {
        return function (node) {
            return function (handler) {
                return Control_Bind.bind(((dictMonadFRP.MonadCleanup1()).Monad0()).Bind1())(Effect_Class.liftEffect(dictMonadFRP.MonadEffect0())(Specular_Dom_Browser.addEventListener(eventType)(handler)(node)))(function (unsub) {
                    return Control_Monad_Cleanup.onCleanup(dictMonadFRP.MonadCleanup1())(unsub);
                });
            };
        };
    };
};
var liftBuilderWithRun = function (dict) {
    return dict.liftBuilderWithRun;
};
var liftBuilder = function (dict) {
    return dict.liftBuilder;
};
var elDynAttrNS$prime = function (dict) {
    return dict["elDynAttrNS'"];
};
var elDynAttr$prime = function (dictMonadDomBuilder) {
    return elDynAttrNS$prime(dictMonadDomBuilder)(Data_Maybe.Nothing.value);
};
var elDynAttr = function (dictMonadDomBuilder) {
    return function (tagName) {
        return function (dynAttrs) {
            return function (inner) {
                return Data_Functor.map((((dictMonadDomBuilder.Monad0()).Bind1()).Apply0()).Functor0())(Data_Tuple.snd)(elDynAttr$prime(dictMonadDomBuilder)(tagName)(dynAttrs)(inner));
            };
        };
    };
};
var elAttr$prime = function (dictMonadDomBuilder) {
    return function (tagName) {
        return function (attrs) {
            return function (inner) {
                return elDynAttr$prime(dictMonadDomBuilder)(tagName)(Control_Applicative.pure(Specular_FRP_WeakDynamic.applicativeWeakDynamic)(attrs))(inner);
            };
        };
    };
};
var elAttr = function (dict) {
    return dict.elAttr;
};
var elAttr_ = function (dictMonadDomBuilder) {
    return function (tagName) {
        return function (attrs) {
            return elAttr(dictMonadDomBuilder)(tagName)(attrs)(Control_Applicative.pure((dictMonadDomBuilder.Monad0()).Applicative0())(Data_Unit.unit));
        };
    };
};
var el$prime = function (dictMonadDomBuilder) {
    return function (tagName) {
        return function (inner) {
            return elAttr$prime(dictMonadDomBuilder)(tagName)(Data_Monoid.mempty(Foreign_Object.monoidObject(Data_Semigroup.semigroupString)))(inner);
        };
    };
};
var el = function (dictMonadDomBuilder) {
    return function (tagName) {
        return function (inner) {
            return elAttr(dictMonadDomBuilder)(tagName)(Data_Monoid.mempty(Foreign_Object.monoidObject(Data_Semigroup.semigroupString)))(inner);
        };
    };
};
var el_ = function (dictMonadDomBuilder) {
    return function (tagName) {
        return el(dictMonadDomBuilder)(tagName)(Control_Applicative.pure((dictMonadDomBuilder.Monad0()).Applicative0())(Data_Unit.unit));
    };
};
var dynText = function (dict) {
    return dict.dynText;
};
var monadDomBuilderReaderT = function (dictMonadDomBuilder) {
    return {
        text: (function () {
            var $26 = Control_Monad_Trans_Class.lift(Control_Monad_Reader_Trans.monadTransReaderT)(dictMonadDomBuilder.Monad0());
            var $27 = text(dictMonadDomBuilder);
            return function ($28) {
                return $26($27($28));
            };
        })(),
        dynText: (function () {
            var $29 = Control_Monad_Trans_Class.lift(Control_Monad_Reader_Trans.monadTransReaderT)(dictMonadDomBuilder.Monad0());
            var $30 = dynText(dictMonadDomBuilder);
            return function ($31) {
                return $29($30($31));
            };
        })(),
        "elDynAttrNS'": function (ns) {
            return function (tag) {
                return function (attrs) {
                    return function (body) {
                        return function (env) {
                            return elDynAttrNS$prime(dictMonadDomBuilder)(ns)(tag)(attrs)(Control_Monad_Reader_Trans.runReaderT(body)(env));
                        };
                    };
                };
            };
        },
        rawHtml: (function () {
            var $32 = Control_Monad_Trans_Class.lift(Control_Monad_Reader_Trans.monadTransReaderT)(dictMonadDomBuilder.Monad0());
            var $33 = rawHtml(dictMonadDomBuilder);
            return function ($34) {
                return $32($33($34));
            };
        })(),
        elAttr: function (tag) {
            return function (attrs) {
                return function (body) {
                    return function (env) {
                        return elAttr(dictMonadDomBuilder)(tag)(attrs)(Control_Monad_Reader_Trans.runReaderT(body)(env));
                    };
                };
            };
        },
        liftBuilder: function (b) {
            return Control_Monad_Trans_Class.lift(Control_Monad_Reader_Trans.monadTransReaderT)(dictMonadDomBuilder.Monad0())(liftBuilder(dictMonadDomBuilder)(b));
        },
        liftBuilderWithRun: function (fn) {
            return function (e) {
                return liftBuilderWithRun(dictMonadDomBuilder)(function (benv, run) {
                    return fn(benv, function (benv$prime, m) {
                        return run(benv$prime, Control_Monad_Reader_Trans.runReaderT(m)(e));
                    });
                });
            };
        },
        Monad0: function () {
            return Control_Monad_Reader_Trans.monadReaderT(dictMonadDomBuilder.Monad0());
        }
    };
};
var dynRawHtml = function (dictMonadDomBuilder) {
    return function (dictMonadReplace) {
        return function (dictMonadFRP) {
            return function (dynHtml) {
                return Specular_FRP_Replaceable.weakDynamic_(dictMonadReplace)(dictMonadFRP)(Data_Functor.map(Specular_FRP_WeakDynamic.functorWeakDynamic)(rawHtml(dictMonadDomBuilder))(dynHtml));
            };
        };
    };
};
var domEventWithSample = function (dictMonadFRP) {
    return function (sample) {
        return function (eventType) {
            return function (node) {
                return Control_Bind.bind(((dictMonadFRP.MonadCleanup1()).Monad0()).Bind1())(Specular_FRP_Base.newEvent(dictMonadFRP.MonadEffect0()))(function (v) {
                    return Control_Bind.discard(Control_Bind.discardUnit)(((dictMonadFRP.MonadCleanup1()).Monad0()).Bind1())(onDomEvent(dictMonadFRP)(eventType)(node)(Control_Bind.composeKleisli(Effect.bindEffect)(sample)(v.fire)))(function () {
                        return Control_Applicative.pure(((dictMonadFRP.MonadCleanup1()).Monad0()).Applicative0())(v.event);
                    });
                });
            };
        };
    };
};
var domEvent = function (dictMonadFRP) {
    return domEventWithSample(dictMonadFRP)(function (v) {
        return Control_Applicative.pure(Effect.applicativeEffect)(Data_Unit.unit);
    });
};
export {
    dynText,
    elAttr,
    elDynAttrNS$prime,
    liftBuilder,
    liftBuilderWithRun,
    rawHtml,
    text,
    elDynAttr$prime,
    elDynAttr,
    elAttr$prime,
    elAttr_,
    el$prime,
    el,
    el_,
    dynRawHtml,
    domEventWithSample,
    domEvent,
    onDomEvent,
    monadDomBuilderReaderT
};
//# sourceMappingURL=index.js.map
